import { cn } from "@/lib/helpers/cn";

type DetailItemProps = { key: string; label: string; value: React.ReactNode };

export function DetailItem({ detail }: { detail: DetailItemProps }) {
  return (
    <div>
      <dt className="body-md">
        <b>{detail.label}</b>
      </dt>

      <dd className={cn("body-md tw:!m-0 tw:!font-normal tw:md:row-start-2")}>{detail.value}</dd>
    </div>
  );
}
